import React from 'react';
import { DashboardLayout } from './DashboardLayout';
import { Button } from '../ui';
import { PlusIcon, ClockIcon, GripVerticalIcon, SparklesIcon, MapPinIcon, UsersIcon } from 'lucide-react';
export function AgendaPage() {
  const days = [{
    id: 'day1',
    title: 'Day 1: Arrival & Connection',
    date: 'May 12, 2026',
    items: [{
      time: '14:00',
      duration: '2h',
      title: 'Arrival & Check-in',
      location: 'Main Lobby',
      type: 'logistics'
    }, {
      time: '16:00',
      duration: '1.5h',
      title: 'Welcome Circle & Intentions',
      location: 'Ocean View Terrace',
      type: 'session',
      ai: true
    }, {
      time: '18:30',
      duration: '2h',
      title: 'Welcome Dinner',
      location: 'Beachfront Restaurant',
      type: 'meal'
    }]
  }, {
    id: 'day2',
    title: 'Day 2: Leadership Reset',
    date: 'May 13, 2026',
    items: [{
      time: '07:30',
      duration: '1h',
      title: 'Morning Wellness (Yoga/Hike)',
      location: 'Various',
      type: 'wellness'
    }, {
      time: '09:00',
      duration: '3h',
      title: 'Leadership Reset Module',
      location: 'Grand Ballroom',
      type: 'session'
    }, {
      time: '12:00',
      duration: '1.5h',
      title: 'Lunch & Free Time',
      location: 'Poolside',
      type: 'meal'
    }, {
      time: '13:30',
      duration: '2.5h',
      title: 'Team Trust Workshop',
      location: 'Grand Ballroom',
      type: 'session',
      ai: true
    }, {
      time: '19:00',
      duration: '2.5h',
      title: 'Dine Around in Pods',
      location: 'Resort Restaurants',
      type: 'meal'
    }]
  }];
  const getTypeColor = (type: string) => {
    switch (type) {
      case 'session':
        return 'border-brand-coral bg-brand-coral/5';
      case 'meal':
        return 'border-amber-400 bg-amber-50';
      case 'wellness':
        return 'border-brand-teal bg-brand-teal/5';
      default:
        return 'border-slate-300 bg-slate-50';
    }
  };
  return <DashboardLayout pageTitle="Agenda" breadcrumb="Leadership Reset Retreat" data-id="element-629">
      <div className="flex flex-col lg:flex-row gap-8" data-id="element-630">
        {/* Main Agenda Area */}
        <div className="flex-1 space-y-8" data-id="element-631">
          <div className="flex justify-between items-center" data-id="element-632">
            <div className="flex bg-slate-100 p-1 rounded-lg" data-id="element-633">
              <button className="px-4 py-1.5 text-sm font-medium rounded-md bg-white text-brand-navy shadow-sm" data-id="element-634">
                Timeline View
              </button>
              <button className="px-4 py-1.5 text-sm font-medium rounded-md text-slate-600 hover:text-slate-900" data-id="element-635">
                Grid View
              </button>
            </div>
            <Button variant="primary" size="sm" data-id="element-636">
              <PlusIcon className="w-4 h-4 mr-2" data-id="element-637" /> Add Session
            </Button>
          </div>

          <div className="space-y-10" data-id="element-638">
            {days.map(day => <div key={day.id} data-id="element-639">
                <div className="flex items-baseline gap-4 mb-6 pb-2 border-b border-slate-200" data-id="element-640">
                  <h2 className="text-xl font-bold text-brand-navy" data-id="element-641">
                    {day.title}
                  </h2>
                  <span className="text-sm text-slate-500 font-medium" data-id="element-642">
                    {day.date}
                  </span>
                </div>

                <div className="space-y-3" data-id="element-643">
                  {day.items.map((item, idx) => <div key={idx} className={`flex items-stretch gap-4 p-4 rounded-xl border-l-4 border-y border-r border-y-slate-100 border-r-slate-100 bg-white shadow-sm hover:shadow-md transition-shadow group ${getTypeColor(item.type).split(' ')[0]}`} data-id="element-644">
                      <div className="flex flex-col items-center justify-center px-2 text-slate-400 cursor-grab opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-645">
                        <GripVerticalIcon className="w-5 h-5" data-id="element-646" />
                      </div>

                      <div className="w-24 shrink-0 pt-1" data-id="element-647">
                        <div className="font-bold text-brand-navy" data-id="element-648">
                          {item.time}
                        </div>
                        <div className="text-xs text-slate-500 font-medium" data-id="element-649">
                          {item.duration}
                        </div>
                      </div>

                      <div className="flex-1" data-id="element-650">
                        <div className="flex items-start justify-between gap-4" data-id="element-651">
                          <div data-id="element-652">
                            <h3 className="font-bold text-slate-900 text-base mb-1 flex items-center gap-2" data-id="element-653">
                              {item.title}
                              {item.ai && <span className="inline-flex items-center gap-1 bg-brand-teal/10 text-brand-teal text-[10px] uppercase tracking-wider font-bold px-2 py-0.5 rounded-full" data-id="element-654">
                                  <SparklesIcon className="w-3 h-3" data-id="element-655" /> AI
                                  Suggested
                                </span>}
                            </h3>
                            <div className="flex items-center gap-4 text-sm text-slate-500" data-id="element-656">
                              <span className="flex items-center gap-1" data-id="element-657">
                                <MapPinIcon className="w-3.5 h-3.5" data-id="element-658" />{' '}
                                {item.location}
                              </span>
                              {item.type === 'session' && <span className="flex items-center gap-1" data-id="element-659">
                                  <UsersIcon className="w-3.5 h-3.5" data-id="element-660" /> All
                                  Attendees
                                </span>}
                            </div>
                          </div>
                          <Button variant="ghost" size="sm" className="opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-661">
                            Edit
                          </Button>
                        </div>
                      </div>
                    </div>)}
                </div>

                <button className="mt-4 w-full py-3 border-2 border-dashed border-slate-200 rounded-xl text-sm font-medium text-slate-500 hover:bg-slate-50 hover:text-brand-navy hover:border-slate-300 transition-colors flex items-center justify-center gap-2" data-id="element-662">
                  <PlusIcon className="w-4 h-4" data-id="element-663" /> Add block to{' '}
                  {day.title.split(':')[0]}
                </button>
              </div>)}
          </div>
        </div>

        {/* Sidebar */}
        <div className="w-full lg:w-80 space-y-6" data-id="element-664">
          <div className="bg-brand-navy rounded-2xl p-6 text-white shadow-soft" data-id="element-665">
            <div className="flex items-center gap-2 mb-4" data-id="element-666">
              <SparklesIcon className="w-5 h-5 text-brand-coral" data-id="element-667" />
              <h3 className="font-bold text-lg" data-id="element-668">AI Suggestions</h3>
            </div>
            <p className="text-sm text-slate-300 mb-4 leading-relaxed" data-id="element-669">
              Based on attendee intake, energy levels typically dip on Day 2
              afternoon.
            </p>
            <div className="bg-white/10 rounded-lg p-3 border border-white/10 mb-3" data-id="element-670">
              <div className="text-sm font-bold mb-1" data-id="element-671">Add Wellness Break</div>
              <div className="text-xs text-slate-300 mb-3" data-id="element-672">
                Suggest 30m break at 14:30 on Day 2.
              </div>
              <Button variant="accent" size="sm" className="w-full" data-id="element-673">
                Apply Suggestion
              </Button>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-6 border border-slate-100 shadow-soft" data-id="element-674">
            <h3 className="font-bold text-brand-navy mb-4" data-id="element-675">Agenda Stats</h3>
            <div className="space-y-4" data-id="element-676">
              <div data-id="element-677">
                <div className="flex justify-between text-sm mb-1" data-id="element-678">
                  <span className="text-slate-600" data-id="element-679">Deep Work / Sessions</span>
                  <span className="font-medium" data-id="element-680">45%</span>
                </div>
                <div className="w-full bg-slate-100 h-2 rounded-full" data-id="element-681">
                  <div className="bg-brand-coral h-2 rounded-full w-[45%]" data-id="element-682"></div>
                </div>
              </div>
              <div data-id="element-683">
                <div className="flex justify-between text-sm mb-1" data-id="element-684">
                  <span className="text-slate-600" data-id="element-685">Connection / Meals</span>
                  <span className="font-medium" data-id="element-686">35%</span>
                </div>
                <div className="w-full bg-slate-100 h-2 rounded-full" data-id="element-687">
                  <div className="bg-amber-400 h-2 rounded-full w-[35%]" data-id="element-688"></div>
                </div>
              </div>
              <div data-id="element-689">
                <div className="flex justify-between text-sm mb-1" data-id="element-690">
                  <span className="text-slate-600" data-id="element-691">Wellness / Free Time</span>
                  <span className="font-medium" data-id="element-692">20%</span>
                </div>
                <div className="w-full bg-slate-100 h-2 rounded-full" data-id="element-693">
                  <div className="bg-brand-teal h-2 rounded-full w-[20%]" data-id="element-694"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>;
}